import { useToken } from '@/hooks';
import { Logout } from '@/utils/common';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import axios from 'axios';
import Cookies from 'js-cookie';
import { decryptData } from '@/components/reusable/crypto/Cipher';

const apiServiceNoToast = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL,
  credentials: 'include',
  timeout: 60000, // 1 minute (60,000ms)
});

apiServiceNoToast.interceptors.request.use(
  (config) => {
    const token = useToken();
    const branchCode = Cookies.get('branchCode');
    const companyCode = Cookies.get('companyCode');
    const financialYear = Cookies.get('financialYear');
    const userData = decryptData(localStorage.getItem('userData'));
    const financialYearId = userData?.financialId;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      window.location.href = '/login/';
      return Promise.reject('No token available. Redirecting to login page.');
    }
    if (branchCode) {
      config.headers['Branch'] = branchCode;
    }
    if (companyCode) {
      config.headers['Company'] = companyCode;
    }
    if (financialYear || financialYearId) {
      config.headers['FinancialYear'] = financialYear || financialYearId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

apiServiceNoToast.interceptors.response.use(
  (response) => {
    // showToast(response?.data?.response, 'success');
    return response?.data;
  },

  (error) => {
    if (error?.response?.status === 401) {
      const errMessage = error.response.data.response;
      showToast(errMessage, 'error');
      setInterval(() => {
        Logout();
      }, 2000);
    } else if (error.response?.status === 403) {
      window.location.replace('/permission/denied');
    } else {
      const errMessage =
        error.response?.data?.error?.[0] ?? error?.response?.data?.response;
      showToast(errMessage, 'error');
    }
    if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
      showToast('The request timed out. Please try again later.', 'error');
    } else if (!navigator.onLine) {
      showToast(
        'No Internet Connection. Please check your internet connection',
        'error',
      );
    }
    return Promise.reject(error);
  },
);

export default apiServiceNoToast;
